import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { connect } from "react-redux";
import { setFinancalSchemasTemplates, saveName, newFinStrCreatingStatus} from "../../../store/actions";
import ReactSelect from "./Multiselect";

class AddModal extends React.Component {
  state = {

      modal: false,
      name: "",
      waterfall_item_id: ""

  };

  handleSelect = (value, mode) => {

    let mykey = value.key;
    let myvalue = value.id;

    let multivalue = [];
    let multikey = "";
    if (mode === "multi") {
      value.map(data => {
        multikey = data.key;
        multivalue.push(data.id);
        return data;
      });
      this.setState({ [multikey]: multivalue });
    } else {
      this.setState({ [mykey]: myvalue });
    }

  };

  handleChange = event => {
    this.setState({ name: event.target.value });
  };

  handleClick = () => {

    const {waterfall_item_id,name} = this.state;
    const {setFinancalSchemasTemplates,saveName,toggle,isOpenTabIndexChange,newFinStrCreatingStatus} = this.props;
    const data = {waterfall_item_id};

    setFinancalSchemasTemplates(data);
    saveName(name);
    isOpenTabIndexChange(-1,false);
    newFinStrCreatingStatus(true);
    toggle();

  };

  render() {
    const {isOpen,className,allSchemas,toggle} = this.props;
    const {name} = this.state;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={this.toggle}
          className={className}
        >
          <ModalHeader toggle={this.toggle}>
            Add new financical structure
          </ModalHeader>
          <ModalBody>
            <CardBody>
              <Row>
                <Col xs="8">
                  <FormGroup onSubmit={() => {}}>
                    <Label htmlFor="name">Set a name</Label>
                    <Input
                      type="text"
                      id="name"
                      value={name}
                      placeholder="Enter your name"
                      onChange={this.handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Select contract</Label>{" "}
                    <ReactSelect
                      allSchemas={
                        allSchemas.financicalSchemas
                          .waterfall_item_schemas
                      }
                      handleSelect={this.handleSelect}
                      state_key={"waterfall_item_id"}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={this.handleClick}>
              Add
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default connect(
  null,
  { setFinancalSchemasTemplates, saveName, newFinStrCreatingStatus }
)(AddModal);



// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/Modal.js